import { Component, inject, OnDestroy, signal, Signal, WritableSignal } from '@angular/core';
import { stages } from '../../notification-of-emergency.routes';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ApplicationAppEntityApplicationRead, RoadOccupationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NotificationOfEmergencyOccupationForm,
  NotificationOfEmergencyOccupationFormValue, occupationsToFormValue
} from './forms/notification-of-emergency-occupation.form';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import { AccordionGroupComponent } from '../../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../../common/accordion-item/accordion-item.component';
import {
  NotificationOfEmergencyOccupationPreviewComponent
} from './components/notification-of-emergency-occupation-preview/notification-of-emergency-occupation-preview.component';
import {
  NotificationOfEmergencyOccupationFormComponent
} from './components/notification-of-emergency-occupation-form/notification-of-emergency-occupation-form.component';
import {
  RoadOccupationFormComponent
} from '../../../common/occupation-data-section/components/road-occupation-form/road-occupation-form.component';
import { updateNotificationOfEmergencyOccupations } from '../../../../../../store/actions/application.actions';

@Component({
  selector: 'app-notification-of-emergency-occupation-data-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    AlertComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    NotificationOfEmergencyOccupationPreviewComponent,
    NotificationOfEmergencyOccupationFormComponent,
    RoadOccupationFormComponent
  ],
  providers: [NotificationOfEmergencyOccupationForm],
  templateUrl: './notification-of-emergency-occupation-data-section.component.html'
})
export class NotificationOfEmergencyOccupationDataSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  public store$: Store = inject(Store);

  public route: ActivatedRoute = inject(ActivatedRoute);

  public router: Router = inject(Router);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public currentIndex: WritableSignal<number | undefined> = signal(undefined);

  public showItemForm: boolean = false;

  public form: NotificationOfEmergencyOccupationForm = inject(NotificationOfEmergencyOccupationForm);

  public roadOccupations: WritableSignal<NotificationOfEmergencyOccupationFormValue[]> = signal([]);

  private fetchRoadOccupations: Subscription = toObservable(this.application).subscribe(app => {
    const occupations: Array<RoadOccupationAppEntityApplicationRead> = app?.roadOccupations || [];
    this.roadOccupations.set(occupationsToFormValue(occupations))
  });

  public onAdd(): void {
    this.showItemForm = true;
    this.currentIndex.set(undefined);
  }

  public onEditOccupations(event: Event, i: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.currentIndex.set(i);
    this.showItemForm = true;
    this.form.patchFormValues({
      ...this.roadOccupations()[i]
    });
  }

  public onUpdateOccupations(roadOccupation: NotificationOfEmergencyOccupationFormValue): void {
    if (this.currentIndex() !== undefined) {
      this.roadOccupations.update(v => {
        const arr = [...v];
        arr[this.currentIndex() || 0] = roadOccupation;
        return arr;
      });
      this.currentIndex.set(undefined);
    } else {
      this.roadOccupations.update(v => ([
        ...v,
        roadOccupation
      ]));
    }
    this.showItemForm = false;
    this.form.reset();
  }

  public onRemove(i: number, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.roadOccupations.update(v => {
      v.splice(i, 1);
      return v;
    });
  }

  public submitAndGoNext(): void {
    if (this.roadOccupations().length) {
      this.store$.dispatch(
        updateNotificationOfEmergencyOccupations({
          application: this.application(),
          occupations: this.roadOccupations(),
          successFnc: (applicationId) => {
            this.router.navigate(
              ['../zgody'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        })
      );
    }
  }

  public onCancel(): void {
    this.router.navigate(['../wykonawca'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchRoadOccupations.unsubscribe();
  }

}
